module.exports = __webpack_public_path__ + "static/img/mark.7e48087.png";